class currencySelectorMobile extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.selectEl = this.querySelector("select");
    this.country_code = this.querySelector("[data-country-code]");
  }

  connectedCallback() {
    this.selectEl.addEventListener("change", (e) => {
      e.preventDefault();
      this.country_code.value = this.selectEl.value;
      this.form.submit();
    });
  }
}

if (!customElements.get("currency-selector-mobile")) {
  customElements.define("currency-selector-mobile", currencySelectorMobile);
}
